import 'core-js/stable';
import React, { FC, Suspense, useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import 'regenerator-runtime/runtime';
import RedirectToCustomHtmlOrFrame from 'src/components/base-components/RedirectToCustomHtmlOrFrame';
import { ROUTE_PATHS_TO_HTML } from 'src/utils/constants';
import { lazyWithCustomError } from 'src/utils/lazyWithCustomError';
import { envStrToBoolean } from './helpers/utils';
import ErrorBoundaryComponent from './hoc/ErrorBoundary';
import { I18nProvider } from './hoc/I18Provider';
import { Main } from './pages/Main';
import './styles/index.scss';

const Debugger = lazyWithCustomError(() => import('./Debugger').then((m) => ({ default: m.Debugger })));

if (process.env.REACT_APP_MODE !== 'DEV' && envStrToBoolean(process.env.REACT_APP_SMARTICO_ENABLE)) {
  const script = document.createElement('script');
  script.src = 'https://libs.smartico.ai/smartico.js';
  script.onload = function () {
    // Initialize Smartico once the script is loaded
    (window as any)._smartico.init('93bab8d4-db19-4954-9f9e-094f9e5c5e01-3', { brand_key: 'ad714fa7' });
  };
  document.head.appendChild(script);
}

const App: FC = () => {
  const isEnableMaintenancePage = envStrToBoolean(process.env.REACT_APP_MAINTENANCE_PAGE);
  const pathname = window.location.pathname;
  const isDebuggerMode = envStrToBoolean(process.env.REACT_APP_DEBUGGER_MODE);

  useEffect(() => {
    if (isEnableMaintenancePage) {
      window.location.href = 'https://www.papipromopages.com/underconstruction';
    }
  }, [isEnableMaintenancePage]);

  if (isIOS) {
    // Create a meta tag element
    console.log('new version delivery');
    const viewportMetaTag = document.createElement('meta');

    // Set attributes for the meta tag
    viewportMetaTag.setAttribute('name', 'viewport');
    viewportMetaTag.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');

    // Append the meta tag to the head element of the document
    document.head.appendChild(viewportMetaTag);
  }

  return (
    <I18nProvider>
      <ErrorBoundaryComponent>
        {isDebuggerMode && (
          <Suspense fallback={null}>
            <Debugger />
          </Suspense>
        )}
        {ROUTE_PATHS_TO_HTML.includes(pathname) ? <RedirectToCustomHtmlOrFrame /> : <Main />}
      </ErrorBoundaryComponent>
    </I18nProvider>
  );
};
export default App;
